import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './SensorCounter.css';

/**
 * Affiche le nombre de capteurs pour un état donné.
 * @param {object} props
 * @param {string} props.type Sensor state used as a CSS class.
 * @param {number} props.count
 */
export default function SensorCounter( props ) {
	
	return( 
		<React.Fragment>
			<div className={`sensor-counter-root`}>
				<div  className={`icon ${props.type}`}>
					<FontAwesomeIcon icon={['fas', 'microchip']} className="display-4 mx-2" />
				</div>
				<div  className={`value`}>
					{`${( props.count ) ? props.count : ""}`}
				</div>
			</div>
		</React.Fragment>
	);
}
